export default __webpack_public_path__ + "static/media/Reader's Leggings of the Moon.39eeb564.jpg";